import React, { Component } from 'react'
import { Typeahead } from 'react-bootstrap-typeahead'
import { Icon } from 'antd'

class CustomTypeahead extends Component {
  render() {
    return (
      <div className="ant-input-custom">
        <Icon type="search" className="certain-category-icon" />
        <Typeahead {...this.props} className="ant-input" />
        {this.props.validationMessage && (
          <div className="ant-form-explain">{this.props.validationMessage}</div>
        )}
      </div>
    )
  }
}

export default CustomTypeahead



// WEBPACK FOOTER //
// ./src/containers/items/CustomTypeahead.js